import React from 'react'
import PropTypes from 'prop-types'

const spaceClassName = {
  xs: 'mt-2',
  sm: 'mt-2 lg:mt-4',
  md: 'mt-4',
  lg: 'mt-4 lg:mt-6',
  xl: 'mt-6'
}

function SectionFooter({ children, space = 'md' }) {
  return <div className={spaceClassName[space]}>{children}</div>
}

SectionFooter.propTypes = {
  children: PropTypes.node.isRequired,
  space: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
}

export default SectionFooter
